<template>
  <div class="card card-modal">
    <div class="row card-header">
      <div class="col-12" v-if="agendaContato">Editar nome Agenda</div>
      <div class="col-12" v-else>Nova Agenda</div>
    </div>

    <div class="row card-body">
      <div class="col-12">
        <p class="card-text">Nome Agenda</p>
        <input type="text" class="form-control" v-model="form.nome" />
      </div>

      <div class="col-12">
        <my-alert
          class="alert-danger text-center mt-3"
          @done="showError = false"
          :message="errorMessage"
          :show="showError"
          :timeout="10000"
        ></my-alert>
      </div>
    </div>

    <div class="row card-footer">
      <div class="col-12">
        <button class="btn btn-md col-5 lg btn-danger" @click="$emit('close')">
          <font-awesome-icon icon="times" class="pointer" />
        </button>
        <button class="btn btn-md col-5 lg btn-success offset-2" @click="confirm()">
          <font-awesome-icon icon="check" class="pointer" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["agendaContato"],
  data() {
    return {
      form: {
        nome: this.agendaContato ? this.agendaContato.nome : ""
      }
    };
  },
  methods: {
    async confirm() {
      // Atualizar Titulo Agenda
      if (this.form.nome) {
        if (this.agendaContato) {
          this.agendaContato.nome = this.form.nome;
          let response = await this.$http.put(
            "/v1/v3/agenda",
            this.agendaContato
          );
          if (response.success) {
            this.$toasted.show("Agenda atualizada", {
              icon: "check",
              type: "success"
            });
          } else {
            this.$toasted.show(response.err, { icon: "times", type: "error" });
          }
          this.$emit("close")
          //Criar Agenda Nova
        } else {
          let response = await this.$http.post("/v1/v3/agenda", {
            nome: this.form.nome
          });

          if (!response.success) {
            this.errorMessage = response.err;
            this.showError = true;
          } else {
            this.$toasted.show("Cadastrada com sucesso", {
              icon: "check",
              type: "success"
            });
            this.$emit("close")
          }
        }
      }else{
        this.$toasted.show('Insira um nome', { icon: 'times', type: 'error' });
      }
    }
  }
};
</script>
